import React, { Component } from 'react'
import PropTypes from 'prop-types'
import clone from 'lodash/clone'

class JewelryPanel extends Component {
  constructor (props) {
    super(props)
    this.state = {
      snapshot: {}
    }
  }

  hasSnapshot () {
    return Object.keys(this.state.snapshot).length > 0
  }

  onHide () {
    if (!this.hasSnapshot()) {
      let newSnapshot = this.state.snapshot
      const takeSnapshotForChildren = (children) => {
        // if the children is a single object, store it into an array
        let objs = Array.isArray(children) ? children : [children]
        objs.forEach(
          field => {
            if (field.hasOwnProperty('props') && field.props.hasOwnProperty('initVal')) {
              // push the current value to the snapshot
              newSnapshot[field.props.id] = clone(field.props.value)
              // reset the field to its initVal
              field.props.onChange(field.props.initVal)
            }
            // recursively taking snapshot if the child is not a JewelryPanel and has its own children
            if (field.hasOwnProperty('props') && field.props.hasOwnProperty('children') && field.type.displayName !== 'JewelryPanel') {
              takeSnapshotForChildren(field.props.children)
            }
          }
        )
      }
      takeSnapshotForChildren(this.props.children)
      this.setState({snapshot: newSnapshot})
    }
  }

  onShow () {
    if (this.hasSnapshot()) {
      const restoreSnapshotForChildren = (children) => {
        // if the children is a single object, store it into an array
        let objs = Array.isArray(children) ? children : [children]
        objs.forEach(
          field => {
            if (field.hasOwnProperty('props') && field.props.hasOwnProperty('initVal') && this.state.snapshot[field.props.id]) {
              // Reset the field to the snapshotted value
              field.props.onChange(this.state.snapshot[field.props.id])
            }
            // recursively restoring snapshot if the child is not a JewelryPanel and has its own children
            if (field.hasOwnProperty('props') && field.props.hasOwnProperty('children') && field.type.displayName !== 'JewelryPanel') {
              restoreSnapshotForChildren(field.props.children)
            }
          }
        )
      }
      restoreSnapshotForChildren(this.props.children)
      this.setState({snapshot: {}})
    }
  }

  onReset () {
    if (this.hasSnapshot()) {
      this.setState({snapshot: {}})
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.show && !nextProps.show) {
      this.onHide()
    } else if (!this.props.show && nextProps.show) {
      this.onShow()
    }
    // if the 'Reset All' button is clicked, flush out the snapshot
    if (!this.props.isResetting && nextProps.isResetting) {
      this.onReset()
    }
  }

  render () {
    return (
      <div style={{ display: this.props.show ? 'block' : 'none' }}>
        {React.Children.map(this.props.children, child =>
          child.type.displayName === 'JewelryPanel'
            ? <child.type {...child.props} show={child.props.show && this.props.show} />
            : child
        )}
      </div>
    )
  }
}

JewelryPanel.PropTypes = {
  show: PropTypes.bool.isRequired
}

export default JewelryPanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/jewelry-panel/index.js